// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__d2NRh","rootNoMargin":"styles_rootNoMargin__wzkqi"};